import React, { useEffect } from 'react';
import { PaymentElement } from '@stripe/react-stripe-js';
import { useState } from 'react';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import { Modal } from 'antd';
import trainingsApi from 'utils/trainingsApi';
import axios from 'axios';

export default function CheckoutForm(props) {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    if (props.isAffirmPayment) {
      createCustomer();
    }
  }, []);

  const createCustomer = async () => {
    const affirmPaymentId =
      window.localStorage.getItem('payment_intent_id') || null;
    if (affirmPaymentId) {
      const customerDetails = props.input.map((i) => ({
        name: `${i.firstname} ${i.lastname}`,
        email: i.email.trim(),
        phone: i.phone.trim(),
      }))[0];

      const body = {
        affirmPaymentId,
        customerDetails,
      };

      await axios.post(trainingsApi.createCustomer, body);
    }
  };

  useEffect(() => {
    window.localStorage.setItem(
      props.clientSecret,
      JSON.stringify({
        trainingId: props.trainingId,
        couponId: props.discount ? Number(props.discount.couponId) : 0,
        amount: props.amount,
        trainees: props.input.map((i) => ({
          fullName: `${i.firstname} ${i.lastname}`,
          email: i.email.trim(),
          phone: i.phone.trim(),
          title: i.jobtitle.trim(),
          company: i.company.trim(),
        })),
      }),
    );
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsProcessing(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: `${window.location.origin}/affirm-check`,
      },
    });

    if (error.type === 'card_error' || error.type === 'validation_error') {
      setMessage(error.message);
    } else {
      setMessage('An unexpected error occured.');
    }
    setIsProcessing(false);
  };

  return (
    <Modal
      style={{ top: 50 }}
      visible={props.visible}
      footer={null}
      onCancel={props.handleCancelFunc}
    >
      <form id="payment-form" onSubmit={handleSubmit}>
        <PaymentElement id="payment-element" />
        <div style={{ marginTop: '16px' }}>
          <button
            disabled={isProcessing || !stripe || !elements}
            id="submit"
            className="button-unstyled input-number"
            style={{
              backgroundColor: '#ff4552',
              color: 'white',
              fontFamily: 'Proxima Nova',
              fontWeight: 600,
              padding: '12px 24px',
              borderRadius: '4px',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            <span id="button-text">
              {isProcessing ? 'Processing ... ' : 'Pay now'}
            </span>
          </button>
        </div>
        {/* Show any error or success messages */}
        {message && <div id="payment-message">{message}</div>}
      </form>
    </Modal>
  );
}
